// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1pv5g","header":"MergedInvoice_header__3dOz0"};